const initialState = {
  calendarEvents: {
    loading: false,
    eventsWithoutVisits: [],
    eventsWithVisits: [],
    allEvents: [],
  },
};

export default initialState;
